<template>
  <b-badge
    :style="badgeConfig.badgeStyle"
    class="pr-status-badge"
  >
    {{ badgeConfig.badgeLabel }}
  </b-badge>
</template>

<script>
import { PR_STATUS } from "../../constants/productStock";

export default {
  name: "PrStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      if (this.status === PR_STATUS.DRAFT) {
        return {
          badgeStyle: {
            backgroundColor: "#E3F2FD",
            color: "#3E495B",
          },
          badgeLabel: "รออนุมัติ",
        };
      }
      if (this.status === PR_STATUS.SENT_TO_ERP) {
        return {
          badgeStyle: {
            backgroundColor: "#DBCCF4",
            color: "#3E495B",
          },
          badgeLabel: "อนุมัติแล้ว",
        };
      }
      if (this.status === PR_STATUS.PARTIALLY_ORDERED) {
        return {
          badgeStyle: {
            backgroundColor: "#F6E8B2",
            color: "#3E495B",
          },
          badgeLabel: "สั่งซื้อบางส่วน",
        };
      }
      if (this.status === PR_STATUS.CLOSED) {
        return {
          badgeStyle: {
            backgroundColor: "#D8EFDD",
            color: "#3E495B",
          },
          badgeLabel: "สั่งซื้อครบแล้ว",
        };
      }
      if (this.status === PR_STATUS.CANCELED) {
        return {
          badgeStyle: {
            backgroundColor: "#E9ECEF",
            color: "#3E495B",
          },
          badgeLabel: "ยกเลิก",
        };
      }
      return {
        badgeStyle: {
          backgroundColor: "#E9ECEF",
          color: "#3E495B",
        },
        badgeLabel: "ไม่พบสถานะ",
      };
    },
  },
};
</script>

<style scoped>
.pr-status-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
}
</style>
